<template>
  <div class="statistics-container">
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>应付账款汇总表</span>
      </div>
    </div>

    <div class="search-area">
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="查询时间起"
        aria-label="查询时间起"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="查询时间止"
        aria-label="查询时间止"
        value-format="yyyy-MM-dd"
        clearable
        class="search-input date-picker"
      ></el-date-picker>
      <el-select
        v-model="selectedSupplierUnitNames"
        multiple
        filterable
        placeholder="供应商（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in supplierUnitNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-select
        v-model="selectedProjectNames"
        multiple
        filterable
        placeholder="项目名称（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in projectNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-select
        v-model="selectedContractNames"
        multiple
        filterable
        placeholder="合同名称（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in contractNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
      <el-button v-permission="'statistics:accounts-payable-summary:export'" type="warning" @click="handleExport" icon="el-icon-download" :loading="exportLoading">导出</el-button>
    </div>

    <div class="table-area">
      <el-table
        :data="tableData"
        border
        stripe
        show-summary
        :summary-method="summaryMethod"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column prop="supplierUnitNames" label="供应商" min-width="140" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="projectNames" label="项目名称" min-width="220" align="left">
          <template slot-scope="scope">
            <div v-for="name in splitNames(scope.row.projectNames)" :key="name" class="project-name-line">
              {{ name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="contractName" label="合同名称" min-width="160" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchaseAmount" label="采购金额" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.purchaseAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementAmount" label="结算金额" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.settlementAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="paidAmount" label="已付款金额" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.paidAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="payableBalance" label="应付款余额" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.payableBalance) }}
          </template>
        </el-table-column>
        <el-table-column prop="duePayableAmount" label="已到期应付款金额" width="150" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.duePayableAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="duePayableBalance" label="已到期应付款余额" width="150" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.duePayableBalance) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="goDetail(scope.row)">明细表</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'AccountsPayableSummary',
  data() {
    return {
      startDate: '',
      endDate: '',
      selectedSupplierUnitNames: [],
      selectedProjectNames: [],
      selectedContractNames: [],
      supplierUnitNameOptions: [],
      projectNameOptions: [],
      contractNameOptions: [],
      loading: false,
      exportLoading: false,
      tableData: [],
      /** 当前筛选下全部记录的金额合计（后端计算，非当前页） */
      summaryTotals: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.loadFilterOptions()
    this.loadData()
  },
  methods: {
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.startDate = ''
      this.endDate = ''
      this.selectedSupplierUnitNames = []
      this.selectedProjectNames = []
      this.selectedContractNames = []
      this.pagination.currentPage = 1
      this.loadData()
    },
    loadFilterOptions() {
      this.supplierUnitNameOptions = []
      this.projectNameOptions = []
      this.contractNameOptions = []
      api.statistics.getAccountsPayableSummaryFilterOptions()
        .then(response => {
          if (response.data && response.data.success) {
            const options = response.data.data || {}
            this.supplierUnitNameOptions = options.supplierUnitNames || []
            this.projectNameOptions = options.projectNames || []
            this.contractNameOptions = options.contractNames || []
          }
        })
        .catch(() => {})
    },
    splitNames(value) {
      if (!value) return ['--']
      const names = String(value).split(',').map(name => name.trim()).filter(Boolean)
      return names.length ? names : ['--']
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    goDetail(row) {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      const q = {
        contractId: row.contractId,
        contractName: row.contractName || ''
      }
      if (this.startDate) q.startDate = this.startDate
      if (this.endDate) q.endDate = this.endDate
      this.$router.push({ name: 'AccountsPayableSummaryDetail', query: q })
    },
    handleExport() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      this.exportLoading = true
      const params = {}
      if (this.startDate) params.startDate = this.startDate
      if (this.endDate) params.endDate = this.endDate
      if (this.selectedSupplierUnitNames && this.selectedSupplierUnitNames.length > 0) {
        params.supplierUnitNames = this.selectedSupplierUnitNames
      }
      if (this.selectedProjectNames && this.selectedProjectNames.length > 0) {
        params.projectNames = this.selectedProjectNames
      }
      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames
      }
      api.statistics.exportAccountsPayableSummary(params)
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = response.headers['content-disposition']
          let fileName = '应付账款汇总表.xlsx'
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=([^;]+)/i)
            if (match) {
              fileName = decodeURIComponent(match[1].replace(/^UTF-8''/, '').trim())
            }
          }
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00'
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    summaryMethod() {
      const t = this.summaryTotals || {}
      const fmt = k => this.formatAmount(t[k] != null ? t[k] : 0)
      return [
        '合计',
        '',
        '',
        fmt('purchaseAmountSum'),
        fmt('settlementAmountSum'),
        fmt('paidAmountSum'),
        fmt('payableBalanceSum'),
        fmt('duePayableAmountSum'),
        fmt('duePayableBalanceSum'),
        ''
      ]
    },
    loadData() {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        this.$message.warning('查询时间起不能晚于查询时间止')
        return
      }
      this.loading = true
      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize
      }
      if (this.startDate) params.startDate = this.startDate
      if (this.endDate) params.endDate = this.endDate
      if (this.selectedSupplierUnitNames && this.selectedSupplierUnitNames.length > 0) {
        params.supplierUnitNames = this.selectedSupplierUnitNames
      }
      if (this.selectedProjectNames && this.selectedProjectNames.length > 0) {
        params.projectNames = this.selectedProjectNames
      }
      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames
      }
      api.statistics.getAccountsPayableSummary(params)
        .then(response => {
          if (response.data && response.data.success) {
            const data = response.data.data || {}
            this.tableData = data.content || []
            this.pagination.total = data.totalElements || 0
            this.summaryTotals = data.totals || null
          } else {
            this.tableData = []
            this.summaryTotals = null
            this.$message.error(response.data?.message || '获取应付账款汇总表失败')
          }
        })
        .catch(err => {
          this.tableData = []
          this.summaryTotals = null
          this.$message.error(err.response?.data?.message || '获取应付账款汇总表失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-container {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.title-mark {
  width: 4px;
  height: 18px;
  background: #409eff;
  margin-right: 10px;
}
.search-area {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.search-input {
  width: 200px;
}
.select-multi {
  min-width: 200px;
  max-width: 280px;
}
.date-picker {
  width: 200px;
}
.table-area {
  margin-bottom: 20px;
}
.project-name-line {
  line-height: 1.5;
  white-space: normal;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}
::v-deep .el-table__footer-wrapper tbody td {
  background-color: #fafafa !important;
  font-weight: 600;
}
</style>
